export default function () {
  return {
    printers: []
  };
}
